module.exports = __webpack_public_path__ + "static/img/d6-3xx.973e7ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/english/home/pc/role/d6-3xx.png
// module id = 5PqD
// module chunks = 0